import Vue from "vue";
import Router from "vue-router";
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/

//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/error/401",
    component: () => import("@/views/error/401"),
    hidden: true,
  },
  {
    path: "/error/404",
    component: () => import("@/views/error/404"),
    hidden: true,
  },
  {
    path: "",
    component: Layout,
    name: "",
    hidden: true,
    children: [
      // {
      //   path: "/",
      //   name: "Dashboard",
      //   meta: { title: "首页", icon: "dashboard", affix: true },
      //   component: () => import("@/views/dashboard/index")
      // }
    ],
  },
  {
    path: "",
    component: Layout,
    name: "Info",
    hidden: true,
    children: [
      {
        path: "/info",
        component: () => import("@/views/info/index"),
      },
    ],
  },
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/views/redirect/index"),
      },
    ],
  },
];

//实例化vue的时候只挂载constantRouter
export default new Router({
  mode: "history",
  routes: constantRouterMap,
});

//异步挂载的路由
//动态需要根据权限加载的路由表
//meta无permissions字段则不做权限控制
export const asyncRouterMap = [
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "forum",
    meta: {
      title: "论坛管理",
      permissions: ["admin", "forum_post", "forum_user", "forum_comment"],
      icon: "users",
    },
    children: [
      {
        path: "/forum/post",
        name: "post",
        component: () => import("@/views/forum/post"),
        meta: {
          keepAlive: false,
          title: "帖子列表",
          permissions: ["admin", "forum_post"],
        },
      },
      {
        path: "/forum/user",
        name: "user",
        component: () => import("@/views/forum/user"),
        meta: {
          keepAlive: false,
          title: "论坛用户",
          permissions: ["admin", "forum_user"],
        },
      },
      {
        path: "/forum/comment",
        name: "comment",
        component: () => import("@/views/forum/comment"),
        meta: {
          keepAlive: false,
          title: "评论管理",
          permissions: ["admin", "forum_comment"],
        },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "User",
    meta: {
      title: "用户管理",
      permissions: ["admin", "user_list"],
      icon: "users",
    },
    children: [
      {
        path: "/user/list",
        name: "Users",
        component: () => import("@/views/user/index"),
        meta: {
          keepAlive: false,
          title: "用户列表",
          permissions: ["admin", "user_list"],
        },
      },
    ],
  },

  // {
  //   path: "",
  //   component: Layout,
  //   alwaysShow: true,
  //   name: "Student",
  //   meta: {
  //     title: "学生管理",
  //     permissions: ["admin", "student_list"],
  //     icon: "users",
  //   },
  //   children: [
  //     {
  //       path: "/student/list",
  //       name: "student",
  //       component: () => import("@/views/student/index"),
  //       meta: {
  //         keepAlive: true,
  //         title: "学生列表",
  //         permissions: ["admin", "student_list"],
  //       },
  //     },
  //     {
  //       path: "/student/class_schedule",
  //       name: "classSchedule",
  //       hidden: true,
  //       component: () => import("@/views/student/class_schedule"),
  //       meta: { title: "学生课表", permissions: ["admin", "student_list"] },
  //     },
  //   ],
  // },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "School",
    meta: {
      title: "学校管理",
      permissions: ["admin", "school_list"],
      icon: "users",
    },
    children: [
      {
        path: "/school/list",
        name: "school-list",
        component: () => import("@/views/school/index"),
        meta: {
          keepAlive: false,
          title: "学校列表",
          permissions: ["admin", "school_list"],
        },
      },
      {
        path: "/school/campus",
        name: "campus",
        component: () => import("@/views/school/campus"),
        meta: { keepAlive: false, title: "校区管理", permissions: ["admin"] },
      },
      {
        path: "/arrange/classtime",
        name: "classtime",
        hidden: true,
        component: () => import("@/views/arrange/classtime"),
        meta: {
          keepAlive: false,
          title: "上课时间设置",
          permissions: ["admin", "arrange_classtime"],
        },
      },
      {
        path: "/school/academy",
        name: "school_academy",
        component: () => import("@/views/school/academy"),
        meta: {
          keepAlive: false,
          title: "院系列表",
          permissions: ["admin", "school_academy"],
        },
      },
      {
        path: "/school/grade",
        name: "grade",
        component: () => import("@/views/school/grade"),
        meta: {
          keepAlive: false,
          title: "年级管理",
          permissions: ["admin", "school_grade"],
        },
      },
      {
        path: "/school/majorlist",
        name: "majorlist",
        hidden: true,
        component: () => import("@/views/school/majorlist"),
        meta: {
          keepAlive: false,
          title: "专业管理",
          permissions: ["admin", "school_list"],
        },
      },
      {
        path: "/school/professional",
        name: "school_professional",
        component: () => import("@/views/school/professional"),
        meta: {
          keepAlive: false,
          title: "专业列表",
          permissions: ["admin", "school_professional"],
        },
      },
      {
        path: "/school/class",
        name: "school-class",
        component: () => import("@/views/school/class"),
        meta: {
          keepAlive: true,
          title: "班级管理",
          permissions: ["admin", "school_list"],
        },
      },
      {
        path: "/student/list",
        name: "student",
        component: () => import("@/views/student/index"),
        meta: {
          keepAlive: true,
          title: "学生列表",
          permissions: ["admin", "student_list"],
        },
      },
      {
        path: "/student/class_schedule",
        name: "classSchedule",
        hidden: true,
        component: () => import("@/views/student/class_schedule"),
        meta: {
          keepAlive: false,
          title: "学生课表",
          permissions: ["admin", "student_list"],
        },
      },
      {
        path: "/school/classroom",
        name: "classroom",
        component: () => import("@/views/school/classroom"),
        meta: {
          keepAlive: false,
          title: "教室管理",
          permissions: ["admin", "school_list"],
        },
      },
      {
        path: "/school/class_record",
        name: "class_record",
        hidden: true,
        component: () => import("@/views/school/class_record"),
        meta: {
          keepAlive: false,
          title: "学生上课记录",
          permissions: ["admin", "school_list"],
        },
      },
      {
        path: "/school/class_record_all",
        name: "class_record_all",
        component: () => import("@/views/school/class_record_all"),
        meta: {
          keepAlive: false,
          title: "学生上课记录",
          permissions: ["admin", "school_list"],
        },
      },
      {
        path: "/school/class_student",
        name: "class_student",
        hidden: true,
        component: () => import("@/views/school/class_student"),
        meta: { keepAlive: false, title: "班级学生", permissions: ["admin"] },
      },
      {
        path: "/school/upgrade",
        name: "upgrade",
        component: () => import("@/views/school/upgrade"),
        meta: {
          keepAlive: false,
          title: "班级自动升级",
          permissions: ["admin", "school_student"],
        },
      },
      {
        path: "/school/class_student_add",
        name: "class_student_add",
        hidden: true,
        component: () => import("@/views/school/class_student_add"),
        meta: {
          keepAlive: false,
          title: "新增班级学生",
          permissions: ["admin", "school_class"],
        },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "education",
    meta: {
      title: "教务管理(电竞教师)",
      permissions: ["admin", "education_teachingtask"],
      icon: "users",
    },
    children: [
      {
        path: "/education/teachingtask",
        name: "teachingtask",
        component: () => import("@/views/education/teachingtask"),
        meta: {
          keepAlive: true,
          title: "教学任务管理",
          permissions: ["admin", "education_teachingtask"],
        },
      },
      {
        path: "/education/studentroster",
        name: "studentroster",
        hidden: true,
        component: () => import("@/views/education/studentroster"),
        meta: {
          keepAlive: false,
          title: "学生花名册",
          permissions: ["admin", "education_teachingtask"],
        },
      },
      {
        path: "/education/teacherprofile",
        name: "teacherprofile",
        hidden: true,
        component: () => import("@/views/education/teacherprofile"),
        meta: {
          keepAlive: false,
          title: "教师资料",
          permissions: ["admin", "education_teachingtask"],
        },
      },
      {
        path: "/education/classschedule",
        name: "classschedule",
        hidden: true,
        component: () => import("@/views/education/classschedule"),
        meta: {
          keepAlive: false,
          title: "班级课程表",
          permissions: ["admin", "education_teachingtask"],
        },
      },
      {
        path: "/education/instructionaldesign",
        name: "instructionaldesign",
        hidden: true,
        component: () => import("@/views/education/instructionaldesign"),
        meta: {
          keepAlive: false,
          title: "教学设计",
          permissions: ["admin", "education_teachingtask"],
        },
      },
      {
        path: "/education/coursewareinfo",
        name: "coursewareinfo",
        hidden: true,
        component: () => import("@/views/education/coursewareinfo"),
        meta: {
          keepAlive: false,
          title: "课件资料",
          permissions: ["admin", "education_teachingtask"],
        },
      },
      {
        path: "/education/studentexam",
        name: "studentexam",
        hidden: true,
        component: () => import("@/views/education/studentexam"),
        meta: {
          keepAlive: false,
          title: "学生考试",
          permissions: ["admin", "education_teachingtask"],
        },
      },
      {
        path: "/education/studentfeedback",
        name: "studentfeedback",
        hidden: true,
        component: () => import("@/views/education/studentfeedback"),
        meta: {
          keepAlive: false,
          title: "学生反馈",
          permissions: ["admin", "education_teachingtask"],
        },
      },
      {
        path: "/education/teachersummary",
        name: "teachersummary",
        hidden: true,
        component: () => import("@/views/education/teachersummary"),
        meta: {
          keepAlive: false,
          title: "教师总结",
          permissions: ["admin", "education_teachingtask"],
        },
      },
      {
        path: "/education/assessment",
        name: "assessment",
        hidden: true,
        component: () => import("@/views/education/assessment"),
        meta: {
          keepAlive: false,
          title: "教学评定",
          permissions: ["admin", "education_teachingtask"],
        },
      },
      {
        path: "/education/checkreviews",
        name: "checkreviews",
        hidden: true,
        component: () => import("@/views/education/checkreviews"),
        meta: {
          keepAlive: false,
          title: "查课评价",
          permissions: ["admin", "education_teachingtask"],
        },
      },
      {
        path: "/education/studentscore",
        name: "studentscore",
        hidden: true,
        component: () => import("@/views/education/studentscore"),
        meta: {
          keepAlive: false,
          title: "学生成绩",
          permissions: ["admin", "education_teachingtask"],
        },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "educationin",
    meta: {
      title: "教务管理(学校教师)",
      permissions: [
        "admin",
        "educationin_schoolinfo",
        "educationin_teachingtask",
      ],
      icon: "users",
    },
    children: [
      {
        path: "/educationin/schoolinfo",
        name: "schoolinfo",
        component: () => import("@/views/educationin/schoolinfo"),
        meta: {
          keepAlive: false,
          title: "学校资料",
          permissions: ["admin", "educationin_schoolinfo"],
        },
      },
      {
        path: "/educationin/teachingtask",
        name: "teachingtask",
        component: () => import("@/views/educationin/teachingtask"),
        meta: {
          keepAlive: true,
          title: "教学任务管理",
          permissions: ["admin", "educationin_teachingtask"],
        },
      },
      {
        path: "/educationin/studentroster",
        name: "studentroster",
        hidden: true,
        component: () => import("@/views/educationin/studentroster"),
        meta: {
          keepAlive: false,
          title: "学生花名册",
          permissions: ["admin", "educationin_teachingtask"],
        },
      },
      {
        path: "/educationin/teacherprofile",
        name: "teacherprofile",
        hidden: true,
        component: () => import("@/views/educationin/teacherprofile"),
        meta: {
          keepAlive: false,
          title: "教师资料",
          permissions: ["admin", "educationin_teachingtask"],
        },
      },
      {
        path: "/educationin/classschedule",
        name: "classschedule",
        hidden: true,
        component: () => import("@/views/educationin/classschedule"),
        meta: {
          keepAlive: false,
          title: "班级课程表",
          permissions: ["admin", "educationin_teachingtask"],
        },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Ordinaryteacher",
    meta: {
      title: "普通教师管理",
      permissions: ["admin", "orteacher_list"],
      icon: "users",
    },
    children: [
      {
        path: "/orteacher/list",
        name: "Orteacher",
        component: () => import("@/views/orteacher/index"),
        meta: {
          keepAlive: false,
          title: "教师列表",
          permissions: ["admin", "orteacher_list"],
        },
      },
      {
        path: "/orteacher/schedule",
        name: "schedule",
        hidden: true,
        component: () => import("@/views/orteacher/schedule"),
        meta: {
          keepAlive: false,
          title: "查看课表",
          permissions: ["admin", "orteacher_list"],
        },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "E-sportsCourses",
    meta: {
      title: "课程管理",
      permissions: [
        "admin",
        "esports_list",
        "esports_distribute",
        "esports_setting",
      ],
      icon: "users",
    },
    children: [
      {
        path: "/esports/list",
        name: "esports",
        component: () => import("@/views/esports/index"),
        meta: {
          keepAlive: false,
          title: "电竞课程列表",
          permissions: ["admin", "esports_list"],
        },
      },
      {
        path: "/esports/distribute",
        name: "distribute",
        component: () => import("@/views/esports/distribute"),
        meta: {
          keepAlive: false,
          title: "电竞课程分配列表",
          permissions: ["admin", "esports_distribute"],
        },
      },
      {
        path: "/esports/ordinary",
        name: "ordinary",
        component: () => import("@/views/esports/ordinary"),
        meta: {
          keepAlive: false,
          title: "普通课程列表",
          permissions: ["admin", "esports_list"],
        },
      },
      {
        path: "/esports/setting",
        name: "esports_setting",
        component: () => import("@/views/esports/setting"),
        meta: {
          keepAlive: true,
          title: "课程表设置",
          permissions: ["admin", "esports_setting"],
        },
      },
      {
        path: "/esports/schedule",
        name: "schedule",
        component: () => import("@/views/esports/schedule"),
        meta: {
          keepAlive: true,
          title: "排课记录",
          permissions: ["admin", "esports_setting"],
        },
      },
      {
        path: "/esports/student",
        name: "operation",
        component: () => import("@/views/esports/student"),
        hidden: true,
        meta: { keepAlive: false, title: "查看学生", permissions: ["admin","esports_setting"] },
      },
      {
        path: "/esports/schedule_del",
        name: "schedule_del",
        component: () => import("@/views/esports/schedule_del"),
        meta: {
          keepAlive: false,
          title: "批量删除课程",
          permissions: ["admin", "esports_setting"],
        },
      },
      {
        path: "/esports/batch",
        name: "batch",
        hidden: true,
        component: () => import("@/views/esports/batch"),
        meta: {
          keepAlive: false,
          title: "批量排课",
          permissions: ["admin", "esports_setting"],
        },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "teacher",
    meta: {
      title: "电竞教师管理",
      permissions: ["admin", "teacher_list", "teacher_distribute"],
      icon: "users",
    },
    children: [
      {
        path: "/teacher/list",
        name: "teacher",
        component: () => import("@/views/teacher/list"),
        meta: {
          keepAlive: false,
          title: "电竞教师列表",
          permissions: ["admin", "teacher_list"],
        },
      },
      {
        path: "/teacher/distribute",
        name: "distribute",
        component: () => import("@/views/teacher/distribute-list"),
        meta: {
          keepAlive: false,
          title: "教师分配列表",
          permissions: ["admin", "teacher_distribute"],
        },
      },
      {
        path: "/teacher/teacherAllot",
        name: "teacherAllot",
        hidden: true,
        component: () => import("@/views/teacher/teacherAllot"),
        meta: {
          keepAlive: false,
          title: "学校分配",
          permissions: ["admin", "teacher_distribute"],
        },
      },
      {
        path: "/teacher/record",
        name: "record",
        hidden: true,
        component: () => import("@/views/teacher/record"),
        meta: {
          keepAlive: false,
          title: "上课记录",
          permissions: ["admin", "teacher_distribute"],
        },
      },
      {
        path: "/teacher/class_schedule",
        name: "class_schedule",
        hidden: true,
        component: () => import("@/views/teacher/class_schedule"),
        meta: {
          keepAlive: false,
          title: "查看课表",
          permissions: ["admin", "teacher_distribute"],
        },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "E-sportsManagement",
    meta: {
      title: "技能课程管理",
      permissions: ["admin", "e_skillCourse", "e_curriculumList"],
      icon: "example",
    },
    children: [
      {
        path: "/E-sportsManagement/skillCourse",
        name: "skillCourse",
        component: () => import("@/views/E-sportsManagement/skillCourse"),
        meta: {
          keepAlive: true,
          title: "技能课程列表",
          permissions: ["admin", "e_skillCourse"],
        },
      },
      {
        path: "/E-sportsManagement/skillCourse_edit",
        name: "skillCourse_edit",
        hidden: true,
        component: () => import("@/views/E-sportsManagement/skillCourse_edit"),
        meta: {
          keepAlive: false,
          title: "技能课程_添加/修改",
          permissions: ["admin", "e_skillCourse"],
        },
      },
      {
        path: "/E-sportsManagement/curriculumList",
        name: "curriculumList",
        component: () => import("@/views/E-sportsManagement/curriculumList"),
        meta: {
          keepAlive: true,
          title: "课程排课列表",
          permissions: ["admin", "e_curriculumList"],
        },
      },
      {
        path: "/E-sportsManagement/curriculumList_edit",
        name: "curriculumList_edit",
        hidden: true,
        component: () =>
          import("@/views/E-sportsManagement/curriculumList_edit"),
        meta: {
          keepAlive: false,
          title: "课程排课_添加/修改",
          permissions: ["admin", "e_curriculumList"],
        },
      },
      {
        path: "/E-sportsManagement/lookApply",
        name: "lookApply",
        hidden: true,
        component: () => import("@/views/E-sportsManagement/lookApply"),
        meta: {
          keepAlive: false,
          title: "查看报名",
          permissions: ["admin", "e_curriculumList"],
        },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "project-Work",
    meta: {
      title: "电竞课程题库管理",
      permissions: ["admin", "operate_indexBanner"],
      icon: "users",
    },
    children: [
      {
        path: "/projectWork/student",
        name: "student",
        component: () => import("@/views/projectWork/student"),
        meta: {
          keepAlive: false,
          title: "学生题库",
          permissions: ["admin", "operate_indexBanner"],
        },
      },
      {
        path: "/projectWork/student_type",
        name: "student_type",
        component: () => import("@/views/projectWork/student_type"),
        meta: {
          keepAlive: false,
          title: "学生题库分类",
          permissions: ["admin"],
        },
      },
      {
        path: "/projectWork/teacher",
        name: "teacher",
        component: () => import("@/views/projectWork/teacher"),
        meta: { keepAlive: false, title: "教师题库", permissions: ["admin"] },
      },

      {
        path: "/projectWork/teacher_type",
        name: "teacher_type",
        component: () => import("@/views/projectWork/teacher_type"),
        meta: {
          keepAlive: false,
          title: "教师题库分类",
          permissions: ["admin"],
        },
      },
      {
        path: "/projectWork/topic_edit",
        name: "topic_edit",
        hidden: true,
        component: () => import("@/views/projectWork/topic_edit"),
        meta: {
          keepAlive: false,
          title: "题目编辑",
          permissions: ["admin", "indexBanner", "operate_indexBanner"],
        },
      },
      {
        path: "/projectWork/answer_record",
        name: "answer_record",
        hidden: true,
        component: () => import("@/views/projectWork/answer_record"),
        meta: { keepAlive: false, title: "答题记录", permissions: ["admin"] },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "role",
    meta: {
      title: "权限管理",
      permissions: ["admin"],
      icon: "content",
    },
    children: [
      {
        path: "/roles",
        name: "role",
        component: () => import("@/views/role/index"),
        meta: { title: "角色列表", permissions: ["role"] },
      },
      {
        path: "/admin/list",
        name: "admin",
        component: () => import("@/views/admin/index"),
        meta: { title: "管理员列表", permissions: ["admin"] },
      },
    ],
  },

  { path: "*", redirect: "/error/404", hidden: true },
];
